import axios from "axios";
import moment from "moment";

export default class {
	static create = async (token, npoId) => {
		let result = {
			data: null,
			error: null
		};

		const data = {
			npoId: npoId,
			date: moment().format()
		};

		await axios
			.post(`${process.env.REACT_APP_API_URL}/likes`, data, {
				headers: { gulink_auth: token }
			})
			.then(resp => {
				if (resp.status === 200) {
					result.data = resp.data;
				}
			})
			.catch(err => {
				result.error = err.response.data;
			});

		return result;
	};

	static check = async (token, npoId) => {
		let result = {
			data: null,
			error: null
		};

		await axios
			.get(`${process.env.REACT_APP_API_URL}/likes/check/${npoId}`, {
				headers: { gulink_auth: token }
			})
			.then(resp => {
				if (resp.status === 200) {
					result.data = resp.data;
				}
			})
			.catch(err => {
				result.error = err.response.data;
			});

		return result;
	};

	static getById = async (token, npoId) => {
		let result = {
			data: null,
			error: null
		};

		await axios
			.get(`${process.env.REACT_APP_API_URL}/likes/${npoId}`, {
				headers: { gulink_auth: token }
			})
			.then(resp => {
				if (resp.status === 200) {
					result.data = resp.data;
				}
			})
			.catch(err => {
				result.error = err.response.data;
			});

		return result;
	};

	static getUserFavoriteNpos = async token => {
		let result = {
			data: null,
			error: null
		};

		await axios
			.post(
				`${process.env.REACT_APP_API_URL}/likes/user`,
				{},
				{
					headers: { gulink_auth: token }
				}
			)
			.then(resp => {
				if (resp.status === 200) {
					result.data = resp.data;
				}
			})
			.catch(err => {
				result.error = err.response.data;
			});

		return result;
	};

	static getAnyUserFavoriteNpos = async userId => {
		let result = {
			data: null,
			error: null
		};

		await axios
			.get(`${process.env.REACT_APP_API_URL}/likes/any-user/${userId}`)
			.then(resp => {
				if (resp.status === 200) {
					result.data = resp.data;
				}
			})
			.catch(err => {
				result.error = err.response.data;
			});

		return result;
	};

	static getCount = async (token, npoId) => {
		let result = {
			data: null,
			error: null
		};

		await axios
			.get(`${process.env.REACT_APP_API_URL}/likes/count/${npoId}`, {
				headers: { gulink_auth: token }
			})
			.then(resp => {
				if (resp.status === 200) {
					result.data = resp.data;
				}
			})
			.catch(err => {
				result.error = err.response.data;
			});

		return result;
	};

	static remove = async (token, favouriteId) => {
		let result = {
			data: null,
			error: null
		};

		await axios
			.delete(`${process.env.REACT_APP_API_URL}/likes/${favouriteId}`, {
				headers: { gulink_auth: token }
			})
			.then(resp => {
				if (resp.status === 200) {
					result.data = resp.data;
				}
			})
			.catch(err => {
				result.error = err.response.data;
			});

		return result;
	};
}
